import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Link from "next/link";
import classnames from "classnames";
import dynamic from "next/dynamic";

import { makeBookUrl } from "@/utils/routes/routes";
import { Typography } from "@/components/index";
import { selectorMainTreeLangMap } from "@/shared/store/mainTree/selectors";

import styles from "./book-list.module.scss";

const BookCover = dynamic(() => import("@/shared/components/BookCoverView"), {
  ssr: false,
});

const BookList = ({
  items,
  isGridView,
  isShowTitle,
  isShowTitlesAsLabels,
  className,
  onClickItem,
}) => {
  const langMap = useSelector(selectorMainTreeLangMap);

  const showTitle = isShowTitle && isGridView && langMap;

  return (
    <div
      className={classnames(
        styles["book-list"],
        className,
        isGridView ? styles["grid"] : styles["list"],
      )}
    >
      {items.map((item, key) => {
        const href = makeBookUrl(item.id);

        const Wrapper = showTitle ? "div" : React.Fragment; // TODO: Fast-implementing, pls refactor.

        const view = onClickItem ? (
          <div className={styles["book-list-item__image"]} onClick={() => onClickItem(item)}>
            <BookCover className={styles["book-list-item__cover"]} book={item} />
          </div>
        ) : (
          <Link
            className={styles["book-list-item__image"]}
            href={href}
          >
            <BookCover className={styles["book-list-item__cover"]} book={item} />
          </Link>
        );

        return (
          <Wrapper key={key} className={styles["book-wrapper"]}>
            <div className={styles["book-list-item"]}>
              {isGridView && view}
              {!isGridView && (
                <>
                  {view}
                  <Link key={key} href={href} className={styles["book-list-item-title"]}>
                    <span>{item.title}</span>
                  </Link>
                  <div className={styles["book-list-item-code"]}>{item.code}</div>
                </>
              )}
            </div>
            {showTitle && (
              <Typography align="center" variant="body3" clamp={2} color="default">
                {isShowTitlesAsLabels ? item.title : langMap[item.lang]}
              </Typography>
            )}
          </Wrapper>
        );
      })}
    </div>
  );
};

BookList.propTypes = {
  items: PropTypes.array,
  isGridView: PropTypes.bool,
  isShowTitle: PropTypes.bool,
  onClickItem: PropTypes.func,
  className: PropTypes.string,
};

export default BookList;
